<template>
  <div v-if="partner" class="coop-login" :style="{ backgroundImage: 'url(' + partner.loginBg + ')' }">
    <img class="coop-login-title" :src="partner.loginTitle" alt="PARK&amp;CHARGE 领取权益">

    <div class="coop-form">
      <input v-model="phoneCode" type="tel" maxlength="11" class="coop-input" placeholder="请输入手机号">

      <div class="coop-row">
        <input v-model="kaptcha" type="text" maxlength="4" class="coop-input" placeholder="请输入验证码">
        <img v-if="codeUrl" :src="codeUrl" class="coop-side" alt="图形验证码" @click="fetchKaptcha">
        <div v-else class="coop-side coop-side-text" @click="fetchKaptcha">点击获取</div>
      </div>

      <div class="coop-row">
        <input v-model="identifyingCode" type="tel" maxlength="4" class="coop-input" :disabled="phoneCode === ''" placeholder="请输入短信验证码">
        <button class="coop-side coop-side-text" :disabled="!isNaN(seconds) || phoneCode.length !== 11 || kaptcha.length !== 4" @click="onUserCode">
          {{ seconds }}<i v-if="!isNaN(seconds)">S</i>
        </button>
      </div>

      <div class="coop-agree-row">
        <input id="coopAgree" v-model="agreeChecked" type="checkbox" class="coop-checkbox">
        <label class="coop-agree-text" for="coopAgree">同意</label><router-link class="coop-link" to="/userTreaty">《用户协议》</router-link><router-link class="coop-link" to="/policy">《隐私政策》</router-link>
      </div>

      <button class="coop-submit" :disabled="phoneCode.length !== 11 || identifyingCode.length !== 4 || !agreeChecked" @click="onUserLogin">登录</button>
    </div>

    <Tip :message="message" :type="tipType" :show="tipShow" />
  </div>
</template>

<script>
import { loginByUsersend, loginByUsername, getKaptchaUrl } from '../../api/login.js'
import config from '@/config/Config.vue'
import { getPartner } from './partners'

export default {
  name: 'CoopLogin',
  data() {
    return {
      partnerCode: '',
      partner: null,
      phoneCode: '',
      kaptcha: '',
      identifyingCode: '',
      timeStamp: '',
      codeUrl: '',
      seconds: '获取验证码',
      intervalTime: null,
      agreeChecked: false,
      message: '',
      tipShow: '0',
      tipType: ''
    }
  },
  created() {
    this.partnerCode = this.$route.params.partner
    this.partner = getPartner(this.partnerCode)
    if (!this.partner) {
      this.$router.replace('/')
      return
    }
    this.fetchKaptcha()
  },
  destroyed() {
    if (this.intervalTime != null) {
      clearInterval(this.intervalTime)
    }
  },
  methods: {
    fetchKaptcha() {
      getKaptchaUrl().then(res => {
        const data = res.data
        if (data.status === 200) {
          this.codeUrl = config.API_URL + data.result.url
          this.timeStamp = data.result.timeStamp
        }
      })
    },
    showTip(msg, type) {
      this.tipShow = '1' + Math.random() * 1000
      this.message = msg
      this.tipType = type
    },
    onUserCode() {
      if (!/^((1[3-9][0-9]))\d{8}$/.test(this.phoneCode)) {
        this.showTip('手机号格式错误', 'error')
        return
      }
      loginByUsersend({ phone: this.phoneCode, kaptcha: this.kaptcha, timeStamp: this.timeStamp }).then(response => {
        if (response.data.status === 200) {
          this.showTip('发送成功', 'success')
          this.seconds = 59
          this.intervalTime = setInterval(() => {
            if (this.seconds > 1) {
              this.seconds--
            } else {
              this.seconds = '获取验证码'
            }
          }, 1000)
        } else {
          this.showTip(response.data.message, 'warning')
          this.fetchKaptcha()
        }
      })
    },
    onUserLogin() {
      if (!/^((1[3-9][0-9]))\d{8}$/.test(this.phoneCode)) {
        this.showTip('手机号格式错误', 'error')
        return
      }
      if (!this.agreeChecked) {
        return
      }
      loginByUsername({
        userPhone: this.phoneCode,
        verificationCode: this.identifyingCode,
        userSource: this.partner.userSource
      }).then(response => {
        if (response.data.status === 200) {
          const result = response.data.result
          localStorage.setItem('token', result.token)
          if (result.openId) {
            localStorage.setItem('openId', result.openId)
          }
          this.$router.replace('/coop/' + this.partnerCode + '/success')
        } else {
          this.showTip(response.data.message, 'warning')
        }
      })
    }
  }
}
</script>

<style scoped>
/*
 * 尺寸统一用 vw, 与设计稿 750 宽一一对应(1vw = 7.5 设计px), 各屏等比还原。
 * 底图 750x1350 贴底; 屏幕比图更高时, 上方用图顶行的纯色 #2D5988 补齐, 接缝不可见。
 */
.coop-login {
  min-height: 100vh;
  box-sizing: border-box;
  /*
   * 这里必须用 padding 不能用子元素的 margin-top:
   * 首个子元素的上外边距会穿透塌陷成本元素的外边距, 把整个蓝底往下推、露出 body 白底。
   */
  padding-top: 23vw;
  padding-bottom: 8vw;
  background-color: #2D5988;
  background-size: 100% auto;
  background-position: bottom center;
  background-repeat: no-repeat;
  color: #fff;
  text-align: center;
}

/* 标题组图自带上下透明留白(上 11.7vw / 下 10.7vw), 间距靠它撑 */
.coop-login-title {
  display: block;
  width: 100%;
}

.coop-form {
  padding: 0 14vw;
}

.coop-input {
  display: block;
  width: 100%;
  height: 10.4vw;
  padding: 0 3.2vw;
  box-sizing: border-box;
  border: 0.13vw solid rgba(255, 255, 255, 0.45);
  border-radius: 1vw;
  background-color: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 3.7vw;
}

.coop-input::placeholder {
  color: rgba(255, 255, 255, 0.75);
}

.coop-input:disabled {
  opacity: 0.65;
}

.coop-row {
  display: flex;
  margin-top: 2.9vw;
}

.coop-row .coop-input {
  flex: 1;
  min-width: 0;
}

/* 图形验证码 / 获取验证码, 与设计稿右侧框同宽 */
.coop-side {
  width: 30.7vw;
  height: 10.4vw;
  margin-left: 2.3vw;
  flex-shrink: 0;
  box-sizing: border-box;
  border: 0.13vw solid rgba(255, 255, 255, 0.45);
  border-radius: 1vw;
  background-color: rgba(255, 255, 255, 0.18);
}

.coop-side-text {
  padding: 0;
  line-height: 10.14vw;
  color: rgba(255, 255, 255, 0.85);
  font-size: 3.4vw;
  text-align: center;
}

.coop-side-text:disabled {
  opacity: 0.6;
}

.coop-agree-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 3.2vw;
  font-size: 3.2vw;
  line-height: 3.7vw;
  text-align: left;
}

/* 原生 checkbox 无法样式化, 关掉默认外观自己画 */
.coop-checkbox {
  position: relative;
  width: 3.7vw;
  height: 3.7vw;
  margin: 0 1.6vw 0 0;
  flex-shrink: 0;
  border: 0.13vw solid rgba(255, 255, 255, 0.7);
  border-radius: 0.5vw;
  background-color: rgba(255, 255, 255, 0.25);
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.coop-checkbox:checked {
  border-color: #285FAB;
  background-color: #285FAB;
}

/* 勾用白色 —— 底色换成蓝之后, 原来的深蓝勾几乎看不见 */
.coop-checkbox:checked::after {
  content: '';
  position: absolute;
  top: 0.1vw;
  left: 1.15vw;
  width: 1vw;
  height: 2.1vw;
  border: solid #fff;
  border-width: 0 0.4vw 0.4vw 0;
  transform: rotate(45deg);
}

.coop-agree-text {
  margin: 0;
  font-weight: 400;
}

.coop-link {
  color: #fff;
  font-weight: 500;
  text-decoration: none;
}

.coop-link:hover,
.coop-link:focus,
.coop-link:active {
  color: #fff;
  text-decoration: none;
}

.coop-submit {
  display: block;
  width: 100%;
  height: 10.4vw;
  margin-top: 4.3vw;
  padding: 0;
  border: 0.13vw solid rgba(255, 255, 255, 0.45);
  border-radius: 1vw;
  background-color: rgba(255, 255, 255, 0.28);
  color: #fff;
  font-size: 4.3vw;
}

.coop-submit:active {
  background-color: rgba(255, 255, 255, 0.4);
}

.coop-submit:disabled {
  opacity: 0.6;
}
</style>
